import { Parametre } from './parametre'
import { Type } from '../type'
import { isList } from '../type-helper'

function isRef(comp, param) {
  return comp.type.name === Type.REFERENCE.name && comp.referentiel === param.reference
}

function isString(comp) {
  console.log('comp', comp)
  return comp.type.name === Type.TEXT.name
}

function isNumber(comp) {
  console.log('comp', comp)
  return comp.type.name === Type.NUMERIC.name
}

export const Types = Object.freeze({
  BOOLEAN: {
    label: 'Booléen',
    validate: value => value.toLowerCase() === 'true' || value.toLowerCase() === 'false',
    condition: () => false,
  },
  NUMBER: {
    label: 'Nombre',
    validate: value => !isNaN(Number(value)),
    condition: comp => isNumber(comp) || (isList(comp.type) && isNumber(comp.unitComponent)),
  },
  STRING: {
    label: 'Chaine de caractéres',
    validate: value => isNaN(Date.parse(value)),
    condition: comp => isString(comp) || (isList(comp.type) && isString(comp.unitComponent)),
  },
  DATE: { label: 'Date', validate: value => Date.parse(value), condition: comp => comp.type.name === Type.DATE.name },
  BORNE: {
    label: 'Borne',
    validate: () => true,
    condition: comp => comp.type.name === Type.GROUP.name && comp.consistency,
    origines: ['RENVOI'],
  },
  REFERENCE: {
    label: 'Référentiel',
    validate: () => true,
    condition: (comp, param) => isRef(comp, param) || (isList(comp.type) && isRef(comp.unitComponent, param)),
  },
})

export const ALL_FUNCTION_TYPES = [Types.NUMBER, Types.BOOLEAN, Types.STRING, Types.REFERENCE, Types.DATE, Types.BORNE]

export const Origines = ['VALEUR_SAISIE', 'VARIBALE_CLIENT', 'RENVOI', 'CONTEXTE', 'FONCTION']

export class ParametreFonction {
  parametre
  obligatoire
  origines
  origineDefaut
  valeurOrigine

  constructor(
    parametre = new Parametre(),
    obligatoire = false,
    origines = [],
    origineDefaut = null,
    valeurOrigine = ''
  ) {
    this.parametre = parametre
    this.obligatoire = obligatoire
    this.origines = origines
    this.origineDefaut = origineDefaut
    this.valeurOrigine = valeurOrigine
  }

  static NULL = new ParametreFonction()
}

export default class Fonction {
  nom
  type
  reference
  referenceObj = null
  description
  tags
  exemple
  paramList

  constructor(nom = '', type = null, reference = null, description = '', tags = [], exemple = '', paramList = []) {
    this.nom = nom
    this.type = type
    this.reference = reference
    this.description = description
    this.tags = tags
    this.exemple = exemple
    this.paramList = paramList
  }

  static NULL = new Fonction()
}
